export const apiUrls = {
  marketoBaseURL:
    "/us-dev-shared-services-cdx-imaging-marketo-integration-service",
  caseManagementBaseURL:
    "/us-dev-shared-services-cdx-imaging-case-management-service",
  marketoLogin: "/marketo/login",
  caseList: "/case",
  caseByID: "/case/preview",
};

export const browserVersions = {
  Chrome: 109,
  ChromeMax: 123,
  Edge: 124,
  Safari: 16.5,
  Samsung: 25,
  iOS_Safari: 16.5,
  OperaMobile: 80,
  Firefox: 129,
};

export const hostURL = "https://imagingapp.gehealthcare.com";
